/**
 * Hook for trigger entity preview
 *
 * Uses useMutation since the preview is triggered on demand (not automatic).
 * Fetches entities that match a trigger's configuration to show
 * how many would be affected by inactivity or date field triggers.
 */

import { useMutation } from '@tanstack/react-query';
import { workflowsApi } from '../services/workflowsApi';

export interface TriggerPreviewRequest {
  triggerType: 'trigger_inactivity' | 'trigger_date_field';
  config: Record<string, unknown>;
  page?: number;
  limit?: number;
}

export interface TriggerPreviewEntity {
  id: string;
  name: string;
  subtitle: string;
  status?: string;
}

export interface TriggerPreviewResponse {
  triggerType: string;
  entityType: string;
  total: number;
  entities: TriggerPreviewEntity[];
  page: number;
  limit: number;
  totalPages: number;
}

export const useTriggerPreview = () => {
  return useMutation({
    mutationFn: (data: TriggerPreviewRequest) =>
      workflowsApi.previewTriggerEntities(data),
  });
};
